import type { MaterialInfo, PartDefinition } from "@rogue/rackbuilder"
import { getRackModel } from "@/js/pages/product/rackbuilder/modelPaths"
import type { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
export { getFlipX, getFlipZ, getRotateAndFlipX } from "../ftAdjustments"
export { createTrolleyClip, createLatBarClip, createLowRowClip, buildTopWeightStackHardware, buildWeightStack300Plates } from "../FM/ftSharedParts"

// FML Shared Parts — shroud/cutout meshes and FMLContext shared across Standard and Twin FML builders
export interface FMLContext {
  config: RackOptions
  materials: MaterialInfo
  height: RackOptions['height']
  depth: string // '24' | '30' | '43'
}

export function createFMLSideShrouds(left: boolean): PartDefinition {
  return {
    mesh        : getRackModel('FML', 'side shrouds'),
    slots       : {},
    materials   : { default: { material: 'matte' } },
    adjustments : left ? [] : [{ type: 'flip', axis: 'X' }],
  }
}

export function createFMLShroudCutout(left: boolean): PartDefinition {
  return {
    mesh        : getRackModel('FML', `shroud cutout ${left ? 'left' : 'right'}`),
    slots       : {},
    materials   : { default: { material: 'matte' } },
    adjustments : left ? [] : [{ type: 'rotate' as const, axis: 'Y' as const, amount: 180 }],
  }
}
